<template>
  <worker-personal-data-form
    v-if="shouldShowForm"
    @on-save-success="onSaveSuccess"
    @on-is-form-valid="onIsFormValid"
    @update-personal-data="updatePersonalData" />
  <worker-personal-data-view v-else-if="shouldShowView" />
</template>

<script>
import { isStatusApproved } from 'accountant/worker/src/services/approvalService';
import WorkerPersonalDataForm from './WorkerPersonalDataForm';
import WorkerPersonalDataView from './WorkerPersonalDataView';
import store from '../../../../../../store/index';

export default {
  name: 'WorkerPersonalDataTab',
  components: {
    WorkerPersonalDataForm,
    WorkerPersonalDataView,
  },
  props: {
    isEditMode: Boolean,
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    isContractApproved() {
      return isStatusApproved(this.workerBasicInfo?.contractData);
    },
    isPersonalUnregistered() {
      return !this.workerBasicInfo.personalDataProvided;
    },
    shouldShowView() {
      return !this.isPersonalUnregistered;
    },
    shouldShowForm() {
      return this.isEditMode || this.isPersonalUnregistered;
    },
  },
  watch: {
    shouldShowForm: {
      immediate: true,
      handler(value) {
        this.$emit('toggle-edit-mode', value);
      },
    },
  },
  methods: {
    onSaveSuccess() {
      this.$emit('on-save-success');
    },
    updatePersonalData(personalData) {
      this.$emit('update:personal-data', personalData);
    },
    onIsFormValid(value) {
      this.$emit('on-is-form-valid', value);
    },
  },
};
</script>
